import instance from "../utils/network";
import { PubOwnerDto, PubType } from "./cafe";

const url = process.env.REACT_APP_WEB_AUTH_HOST;
export interface UserInfo {
  id: number;
  textId: string;
  email: string;
  username: string;
  nickname: string;
  phoneNumber: string;
  phoneNumberEnc: string;
  birthday: string;
  gender: string;
  role: string;
  grade: string;
  expireType: string;
  profileImageUrl: string | null;
  accessToken: string;
  accountInfo: string | null;
  accountBank: string | null;
  accountOwner: string | null;
  ticketCount: number;
  dailyTicketCount: number;
  kakaoId: number | null;
  naverId: number | null;
  googleId: number | null;
  appleId: number | null;
  exit: boolean;
  validate: boolean;
  agree1: boolean;
  agree2: boolean;
  agree3: boolean;
  agree4: boolean;
  agree5: boolean;
  pubOwners: PubOwnerDto[];
}

export interface AuthLoginPubsResponse {
  pubId: number;
  pubName: string;
  pubOwnerId: number;
  pubType: PubType;
  address: string;
  tokenCreatedAt?: string;
}

export interface AuthLoginResponse {
  accessToken: string;
  userId: number;
  pubOwners: AuthLoginPubsResponse[];
}

export interface LoginRouterState {
  redirect?: string;
  loginType?: string;
  accessToken?: string;
  textId?: string | null;
}

export function authLogin(data: {
  textId?: string;
  password?: string;
  loginType?: string;
  accessToken?: string;
}): Promise<{
  accessToken: string;
  refreshToken: string;
  tokenType: string;
}> {
  return instance.post(`${url}/auth/login`, data);
}

export function sellerLogin(data: {
  accessToken?: string;
  textId?: string;
  password?: string;
}): Promise<{ code: number; message: string; payload: AuthLoginResponse }> {
  return instance.post(`seller/auth/login`, data);
}

export function authPubOwnerToken(pubId: number): Promise<{
  code: number;
  message: string;
  payload: { userId: number; pubId: number; pubOwner: PubOwnerDto };
}> {
  return instance.post(`seller/auth/token/${pubId}`);
}

export function authLogout(pubId: number) {
  return instance.post(`/seller/auth/logout/${pubId}`);
}

export function authDetail(token?: string): Promise<UserInfo> {
  return instance.get(`/auth/detail-info`, {
    headers: token ? { Authorization: token } : undefined,
  });
}

export function authRefresh(
  pubId: number,
  userId: number,
): Promise<{
  code: number;
  message: string;
  payload: { accessToken: string };
}> {
  return instance.post(`/seller/auth/refresh`, { pubId, userId });
}

export function deleteNaverToken(token: string): Promise<any> {
  return instance.delete(`/snslogin/deleteNaverToken?token=${token}`);
}
